export const messagesAdmSettings = {
    pt: {
        message:{
            access: "Acesso",
            dataWifiCredentials: "Credenciais DataWifi",
            linkResetPassword: "Link de redefinição de senha",
            report: "Relatório",
            resendWelcomeEmail: "Reenviar e-mail de boas vindas",
            sendMonthlyPerformanceEmail: "Enviar e-mail de performance mensal",
            unblockMasterLogin: "Desbloquear login master"

        }
    },
    es: {
        message:{
            access:"Acceso",
            dataWifiCredentials: "Credenciales de DataWifi",
            linkResetPassword:"Enlace de redefinición de contraseña",
            report:"Informe",
            resendWelcomeEmail:"Reenvíe el correo electrónico de bienvenida",
            sendMonthlyPerformanceEmail:"Enviar correo electrónico de rendimiento mensual",
            unblockMasterLogin:"Desbloquear la clave maestra de inicio de sesión"
        }
    },
    en: {
        message:{
            access: "Access",
            dataWifiCredentials: "DataWifi Credentials",
            linkResetPassword: "Password reset link",
            report: "Report",
            resendWelcomeEmail: "Resend welcome email",
            sendMonthlyPerformanceEmail: "Send monthly performance e-mail",
            unblockMasterLogin: "Unblock master login"

        }
    }
}
